import React from "react";
import styled, { css } from "styled-components";
import { Input } from "components/bootstrap";
const Wrapper = styled.div(
  ({ theme }) => css`
    width: 100%;

    .growable-input-wrapper {
      display: grid;
      width: 100%;
      max-width: 100%;
      min-width: 0;
      grid-template-columns: minmax(0, 1fr);
    }

    .growable-input-wrapper::after,
    .growable-input-wrapper > textarea {
      grid-area: 1 / 1 / 2 / 2;
    }

    .growable-input-wrapper::after {
      content: attr(data-input-value) ' ';
      white-space: pre-wrap;
      overflow-wrap: break-word;
      visibility: hidden;
      box-sizing: border-box;
      border: 1px solid transparent;
      padding: 6px 12px;
      font-size: ${theme.fonts.size.body};
      line-height: inherit;
    }

    .growable-input-wrapper > textarea {
      resize: none;
      overflow: hidden;
      width: 100%;
      max-width: 100%;
      min-width: 0;
    }
  `
);
const GrowableInput = ({
  bsStyle = void 0,
  className = void 0,
  error = void 0,
  id,
  label = void 0,
  name,
  onBlur,
  onChange,
  readOnly = false,
  required = false,
  title,
  value = "",
  restrictLineBreaks = true
}) => {
  const handleChange = (event) => {
    const sanitizedValue = restrictLineBreaks ? event.target.value.replace(/[\r\n]+/g, " ") : event.target.value;
    onChange({
      target: { name: event.target.name, value: sanitizedValue }
    });
  };
  const handleKeyDown = (event) => {
    if (restrictLineBreaks && event.key === "Enter") {
      event.preventDefault();
    }
  };
  return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      bsStyle,
      className,
      error,
      id,
      label,
      name,
      onBlur,
      onChange: handleChange,
      onKeyDown: handleKeyDown,
      readOnly,
      required,
      rows: 1,
      title,
      type: "textarea",
      value,
      wrapperAttributes: { "data-input-value": value },
      wrapperClassName: "growable-input-wrapper"
    }
  ));
};
export default GrowableInput;
